// ============================================
// FILE: src/components/CartScreen.jsx
// ============================================

import React from 'react';
import { ShoppingCart, Plus, Minus, Trash2 } from 'lucide-react';

const CartScreen = ({ 
  cart, 
  updateQuantity, 
  removeFromCart, 
  getCartTotal,
  getCartCount,
  handleCheckout 
}) => {
  return (
    <div className="pb-20 min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white p-6 rounded-b-3xl">
        <h1 className="text-2xl font-bold">Shopping Cart</h1>
        <p className="text-blue-100">{getCartCount()} items in cart</p>
      </div>

      {cart.length === 0 ? (
        <div className="flex flex-col items-center justify-center mt-20 px-6 text-center">
          <ShoppingCart size={64} className="text-gray-300 mb-4" />
          <h3 className="text-xl font-semibold text-gray-600 mb-2">Your cart is empty</h3>
          <p className="text-gray-400">Add some fresh dairy products to get started!</p>
        </div>
      ) : (
        <div className="p-4">
          {cart.map(item => (
            <div key={item.id} className="bg-white rounded-xl shadow-sm p-4 mb-3 flex items-center">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-3 rounded-lg mr-3">
                <span className="text-3xl">{item.image}</span>
              </div>
              
              <div className="flex-1">
                <h3 className="font-semibold text-gray-800">{item.name}</h3>
                <p className="text-sm text-gray-500">₹{item.price} each</p>
              </div>
              
              <div className="flex items-center gap-2">
                <button
                  onClick={() => updateQuantity(item.id, -1)}
                  className="bg-gray-100 p-1 rounded-lg hover:bg-gray-200"
                >
                  <Minus size={16} className="text-gray-600" />
                </button>
                
                <span className="font-semibold text-gray-800 w-8 text-center">
                  {item.quantity}
                </span>
                
                <button
                  onClick={() => updateQuantity(item.id, 1)}
                  className="bg-gray-100 p-1 rounded-lg hover:bg-gray-200"
                >
                  <Plus size={16} className="text-gray-600" />
                </button>
                
                <button
                  onClick={() => removeFromCart(item.id)}
                  className="ml-2 bg-red-50 p-1 rounded-lg hover:bg-red-100"
                >
                  <Trash2 size={16} className="text-red-500" />
                </button>
              </div>
            </div>
          ))}

          <div className="bg-white rounded-xl shadow-sm p-4 mt-6">
            <div className="flex justify-between mb-2">
              <span className="text-gray-600">Subtotal</span>
              <span className="font-semibold">₹{getCartTotal()}</span>
            </div>
            <div className="flex justify-between mb-2">
              <span className="text-gray-600">Delivery</span>
              <span className="font-semibold text-green-600">Free</span>
            </div>
            <div className="border-t pt-2 mt-2">
              <div className="flex justify-between">
                <span className="text-lg font-bold">Total</span>
                <span className="text-lg font-bold text-blue-600">₹{getCartTotal()}</span>
              </div>
            </div>

            <button 
              onClick={handleCheckout}
              className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-3 rounded-xl font-semibold mt-4 hover:from-blue-600 hover:to-blue-700 transition-all">
              Proceed to Checkout
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartScreen;